export function formatDate(date: string, reverse: boolean = false): string {
  const parsedDate = new Date(date);

  if (!isNaN(parsedDate.getTime())) {
    const day = parsedDate.getDate().toString().padStart(2, "0");
    // getMonth a besoin d'un +1 pour afficher des numéros de date car il va de 0 à 11
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
    return reverse
      ? `${parsedDate.getFullYear()}-${month}-${day}`
      : `${day}-${month}-${parsedDate.getFullYear()}`;
  } else {
    return date;
  }
}
